import Reflux from 'reflux'

export default Reflux.createActions(['getGridInfos','updateFetchAllIcon',
        'updateInnerToolBar','keyDownCast','tabpageUserChanged',
        'getDataGridColumnInfo','updateDataGrid','dynamicColumns','updateControlLabel']);


// WEBPACK FOOTER //
// ./src/actions/UtilActions.js